export const getAuth0Domain = () => {
  if (!window.s4cConfig?.auth0?.domain) {
    throw new Error('No auth0 domain provided');
  }

  return window.s4cConfig.auth0.domain;
};

export const getAuth0ClientId = () => {
  if (!window.s4cConfig?.auth0?.clientId) {
    throw new Error('No auth0 clientId provided');
  }

  return window.s4cConfig.auth0.clientId;
};

export const getAuth0Audience = () => {
  if (!window.s4cConfig?.auth0?.audience) {
    throw new Error('No auth0 audience provided');
  }

  return window.s4cConfig.auth0.audience;
};

export const getAuth0OrganizationId = (): string | undefined => {
  return window.s4cConfig?.auth0?.organizationId;
};

export const AUTH0_CONFIG = {
  AUTH0_DOMAIN: getAuth0Domain(),
  AUTH0_CLIENT_ID: getAuth0ClientId(),
  AUTH0_AUDIENCE: getAuth0Audience(),
  AUTH0_ORGANIZATION_ID: getAuth0OrganizationId(),
};

export default AUTH0_CONFIG;
